<template>
    <v-overlay
      :model-value="overlay"
      class="align-center justify-center"
    >
      <v-progress-circular
        color="primary"
        size="64"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  <v-row>
    <v-col v-for="(card, i) in statList.slice(0, 2)" :key="i" cols="12" md="4" sm="8">
      <custom-card
          :disabled="card.disabled"
          :title="card.title"
          :subTitle="card.subTitle"
          :text="card.text"
          :toPath="card.path"
          :color="card.color"
          :cardColor="card.cardColor"
          @startButtonClicked="goMo"
      ></custom-card>
    </v-col>
  </v-row>
  <v-row>
    <v-col v-for="(card, i) in statList.slice(2, 9)" :key="i" cols="12" md="4" sm="8">
      <custom-card
          :disabled="card.disabled"
          :title="card.title"
          :subTitle="card.subTitle"
          :text="card.text"
          :toPath="card.path"
          :color="card.color"
          :cardColor="card.cardColor"
          @startButtonClicked="goMo"
      ></custom-card>
    </v-col>
  </v-row>
  <v-row>
    <v-col v-for="(card, i) in statList.slice(9, 10)" :key="i" cols="12" md="4" sm="8">
      <custom-card
          :disabled="card.disabled"
          :title="card.title"
          :subTitle="card.subTitle"
          :text="card.text"
          :toPath="card.path"
          :color="card.color"
          :cardColor="card.cardColor"
          @startButtonClicked="goMo"
      ></custom-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios';
import CustomCard from '../../components/card/CustomCard.vue';
export default {
  components: {CustomCard},
  data() {
    return {
      overlay:false,
      statList: [
        {
          title: "StatTidy",
          subTitle: "Tidying data",
          text: "",
          color: "primary",
          cardColor:"blue-lighten-5",
          disabled: true
        },
        {
          title: "StatDesc",
          subTitle: "Describing data",
          text: "",
          color: "primary",
          cardColor:"blue-lighten-5",
          disabled: true
        },
        {
          title: "StatCros",
          subTitle: "Cross-sectional data",
          text: "",
          color: "primary",
          cardColor:"green-lighten-5",
          disabled: true
        },
        {
          title: "StatMo",
          subTitle: "Multi-Omic data",
          text: "To integrate the multi-omic data to predict the incidence of diseases.",
          color: "primary",
          cardColor:"green-lighten-5",
          disabled: true
        },
        {
          title: "StatPanel",
          subTitle: "Panel data",
          text: "To conduct the analysis of the panel data.",
          color: "primary",
          cardColor:"green-lighten-5",
          disabled: true
        },
        {
          title: "StatSurv",
          subTitle: "Survival data",
          text: "To conduct the survival analysis of the censored data.",
          color: "primary",
          cardColor:"green-lighten-5",
          disabled: true
        },
        {
          title: "StatMedt",
          subTitle: "Mediation effect",
          text: "For estimating and screening potential mediation pathways of indigenous biomarkers.",
          color: "primary",
          cardColor:"green-lighten-5",
          disabled: true
        },
        {
          title: "StatMIX",
          subTitle: "Combined effect",
          text: "To analyze mixture effect of the various exposure factors.",
          color: "primary",
          cardColor:"green-lighten-5",
          disabled: true
        },
        {
          title: "StatHEP",
          subTitle: "Human exposome prediction",
          text: "To develop a machine learning model (eg., random forest) to predict blood concentrations of chemicals and prioritize chemicals of health concern.",
          color: "primary",
          cardColor:"green-lighten-5",
          disabled: true
        },
        {
          title: "StatIP",
          subTitle: "Statistical interpretation",
          text: "",
          color: "primary",
          cardColor:"red-lighten-5",
          disabled: true
        }
      ]
    };
  },
  methods: {
    async goMo() {
      this.overlay = true
      try {
        const response = await axios.get('/exposome/set_session', null);
        console.log(response)
      } catch (error) {
        console.log(error)
      }

      try {
        const response = await axios.post('/exposome/InitMomics', null, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        console.log(response)
      } catch (error) {
        console.log(error)
      }
      this.overlay = false
      this.$router.push({ path: '/stat-mo' });
    }
  }
};
</script>

<style scoped></style>